<template>
  <div class="full-height">
    <v-card
      v-show="defaultBox"
      :v-show="true"
      :loading="loadingNotes"
      class="full-height"
    >
      <v-card-title class="noteCard">
        Notes
        <v-spacer></v-spacer>
        <div class="float-right">
          <v-btn
            v-if="isGrantedUser()"
            icon
            color="rba(0,0,0,0.54)"
            @click="
              editableBox = true;
              defaultBox = false;
            "
          >
            <v-icon>mdi-comment</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="full-height" style="height: calc(100% - 68px)">
        <div
          style="overflow-y: auto"
          class="full-height thin-scroll"
          v-html="clientPortal.installationNotes"
        ></div>
      </v-card-text>
    </v-card>
    <edit-installation-notes-dialog
      :client-portal="clientPortal"
      v-show="editableBox"
      @closeEditeBox="
        defaultBox = true;
        editableBox = false;
      "
    >
    </edit-installation-notes-dialog>
    <v-dialog v-model="notesWarningDialog" max-width="500">
      <v-card class="pa-3">
        <v-card-text>
          Attention, vous allez changer d'onglet sans avoir engistré vos notes.
          Êtes-vous sûr·e de vouloir continuer ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelTabChange" color="rgba(0,0,0,0.54)">
            Annuler
          </v-btn>
          <v-btn dark @click="goToTargetTab">Continuer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { defineComponent, ref, watch, toRef } from "@vue/composition-api";
import global from "@/composables/global";
import EditInstallationNotesDialog from "@/components/ClientPortal/EditInstallationNotesDialog.vue";
import { useClientPortal } from "@/composables/client-portal";
import { useRoles } from "../../composables/roles";

export default defineComponent({
  components: {
    EditInstallationNotesDialog,
  },
  props: {
    clientPortal: {
      type: Object,
      required: true,
    },
  },
  setup() {
    /* Import des API */
    const { data } = useClientPortal();
    const { isGrantedUser } = useRoles();

    /* Variables */
    const defaultBox = ref(true);
    const editableBox = ref(false);
    const notesWarningDialog = ref(false);
    let destinationTab = 0;
    let controlTabValue = true;

    /* Méthodes */
    function closeEditeBox(value) {
      if (value) {
        defaultBox.value = true;
        editableBox.value = false;
      }
    }
    const closeNotesWarningDialog = function () {
      notesWarningDialog.value = false;
      destinationTab = 0;
      controlTabValue = true;
    };
    const openNotesWarningDialog = function (targetTab) {
      notesWarningDialog.value = true;
      destinationTab = targetTab;
      controlTabValue = false;
    };
    const goToTargetTab = function () {
      global.selectedAppTab = destinationTab;
      setTimeout(function () {
        closeNotesWarningDialog();
      }, 0);
    };
    const cancelTabChange = function () {
      global.selectedAppTab = 0;
      closeNotesWarningDialog();
    };

    /* Watchers */
    watch(
      () => global.selectedAppTab,
      (newValue, oldValue) => {
        if (
          controlTabValue &&
          editableBox.value && // l'éditeur de notes est affiché
          oldValue == 0 && // on était sur le premier onglet
          newValue > 0 // on va vers un autre onglet que le premier
        ) {
          openNotesWarningDialog(newValue);
          global.selectedAppTab = 0;
        }
      }
    );

    return {
      defaultBox,
      editableBox,
      notesWarningDialog,
      closeEditeBox,
      closeNotesWarningDialog,
      openNotesWarningDialog,
      goToTargetTab,
      cancelTabChange,
      loadingNotes: toRef(data, "loadingNotes"),
      isGrantedUser,
    };
  },
});
</script>
